import { cn } from '@/lib/utils';

interface ChangeChardProps {
  title?: string;
  titleClassName?: string;
  titleAction?: React.ReactNode;
  children: React.ReactNode;
}

export const ChangeCard = ({
  title,
  titleClassName,
  titleAction,
  children,
}: ChangeChardProps) => {
  return (
    <div className="border rounded-md w-5xl mx-auto">
      {title && (
        <div
          className={cn(
            'p-6 flex items-center justify-between',
            titleClassName,
          )}
        >
          <h2 className="text-lg font-semibold">{title}</h2>
          {titleAction && <div className="ml-4">{titleAction}</div>}
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
};
